// Copyright 2016 Sorama B.V.

import { IParameterizedValueConverter2 } from "aurelia-binding-ext";
import { Unit } from "units/Unit";
import { UnitParser } from "units/UnitParser";

export class UnitValueConverter implements IParameterizedValueConverter2<number, number, Unit, Unit> {
    public toView(value: number, from: unknown, to: unknown): number {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined) {
            return null;
        }

        const fromUnit = typeof from === "string" ? UnitParser.Parse(from) : <Unit>from;
        const toUnit = typeof to === "string" ? UnitParser.Parse(to) : <Unit>to;

        if (fromUnit === undefined || toUnit === undefined) {
            return null;
        }

        return toUnit.fromUnit(fromUnit, value);
    }

    public fromView(value: number, from: unknown, to: unknown): number {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null || value === undefined) {
            return null;
        }

        const fromUnit = typeof from === "string" ? UnitParser.Parse(from) : <Unit>from;
        const toUnit = typeof to === "string" ? UnitParser.Parse(to) : <Unit>to;

        return fromUnit.fromUnit(toUnit, value);
    }
}
